var render = function (_h,_vm) {
var _obj;
var _c=_vm._c;return _c('svg',{class:( _obj = {}, _obj[_vm.data.staticClass || ""] = true, _obj['u-flip-left'] =  _vm.props.direction === 'left', _obj ),staticStyle:{"height":".5em","width":".5em","fill":"currentColor"},attrs:{"viewBox":"0 0 16 16","width":"32","height":"32"}},[_c('title',[_vm._t("default")],2),_c('path',{attrs:{"d":"M4 16l8-8-8-8 4 8z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }